import React from 'react';
import {
  Menu,
  User,
  ExternalLink,
  Users,
  Eye,
  TrendingUp,
  FileText,
  CreditCard,
  Activity,
} from 'lucide-react';
import { useOrganization } from '@/contexts/OrganizationContext';
import { GenericGoogleSheetsModal } from '@/shared/ui/export/GenericGoogleSheetsModal';
import type { FixedColumnDef, OptionalColumnDef } from '@/shared/ui/export/types';
import { exportCampaignInfluencersToGoogleSheet } from '../services/campaignInfluencerExport.service';

export interface ExportCampaignInfluencersModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  campaignId: string;
  totalCount?: number;
}

const FIXED_COLUMNS: FixedColumnDef[] = [
  { label: 'S.No.', icon: Menu },
  { label: 'NAME', icon: User },
  { label: 'HANDLE LINK', icon: ExternalLink },
  { label: 'FOLLOWERS', icon: Users },
];

const OPTIONAL_COLUMNS: OptionalColumnDef[] = [
  { id: 'average_views', label: 'Average views', icon: Eye },
  { id: 'engagement_rate', label: 'ER', icon: TrendingUp },
  { id: 'deliverables', label: 'Deliverables', icon: FileText },
  { id: 'fees', label: 'Fees', icon: CreditCard },
  { id: 'status', label: 'Status', icon: Activity },
];

export const ExportCampaignInfluencersModal: React.FC<ExportCampaignInfluencersModalProps> = ({
  open,
  onOpenChange,
  campaignId,
  totalCount = 0,
}) => {
  const { currentOrganization } = useOrganization();

  const handleExport = async (selectedColumns: string[]): Promise<string> => {
    if (!currentOrganization?.id) {
      throw new Error('Unable to detect active organization context.');
    }

    return exportCampaignInfluencersToGoogleSheet({
      campaignId,
      columns: selectedColumns,
      orgId: currentOrganization.id,
    });
  };

  return (
    <GenericGoogleSheetsModal
      open={open}
      onOpenChange={onOpenChange}
      title="Export Campaign Influencers to Google Sheets"
      description="Exports assigned influencers, social profile links, and campaign performance data directly to Google Sheets."
      entityName="Influencers"
      totalCount={totalCount}
      fixedColumns={FIXED_COLUMNS}
      optionalColumns={OPTIONAL_COLUMNS}
      onExport={handleExport}
    />
  );
};
